<div
  class="combined-table-head"
  stick
  [cHead]="cHead"
  [cTableBody]="combTableBody"
  (headerIsStuck)="headerStickinessChanged($event)"
  *ngIf="studentState"
>
  <div class="comp-table-fixed-col-header">
    <student-comp-table-fixed-col-header
      [school]="school"
      [selectedAll]="selectedAll"
      [hasStudentSelected]="hasStudentSelected"
      (addGroupClicked)="addGroupClicked.emit()"
      (addStudentsToGroupClicked)="addStudentsToGroupClicked.emit()"
      (removeStudentsFromGroupClicked)="removeStudentsFromGroupClicked.emit()"
      (selectAllChange)="selectAllChange.emit($event)"
      class="fixed-col-header"
    ></student-comp-table-fixed-col-header>
  </div>
  <div class="comp-table-head" #compHead>
    <student-comp-table-head
      [groupStatusSort]="groupStatusSort"
      [groupStatusFilters]="groupStatusFilters"
      [panels]="panels"
      [columns]="columns"
      [districtMetrics]="districtMetrics"
      [schoolOverall]="schoolOverall"
      [groupCriteria]="groupCriteria"
      [school]="school"
      [sortsAndFilters]="sortsAndFilters"
      (sortsFiltersSelected)="sortsFiltersSelected.emit($event)"
    ></student-comp-table-head>
  </div>
</div>
<div class="combined-table-body" #combinedTableBody *ngIf="studentState">
  <div class="comp-table-fixed-col">
    <student-comp-table-fixed-col
      [students]="studentState?.students"
      (rowHoveredEvent)="fixedColRowHovered($event)"
      [bodyRowHoveredIndex]="bodyRowHoveredIndex"
      [fixedColRowHoveredIndex]="fixedColRowHoveredIndex"
      [schools]="schools"
      (studentSelected)="studentSelected.emit($event)"
    ></student-comp-table-fixed-col>
  </div>
  <div
    class="comp-table-body"
    #compBody
    scroll
    [cHead]="cHead"
    (scroll)="onScroll($event)"
  >
    <student-comp-table-body
      [columns]="columns"
      [students]="studentState?.students"
      (rowHoveredEvent)="bodyRowHovered($event)"
      [fixedColRowHoveredIndex]="fixedColRowHoveredIndex"
      (arrowClickedEvent)="arrowClicked($event)"
    >
    </student-comp-table-body>
  </div>
</div>
<div *ngIf="!studentState || (studentState && studentState.pending)">
  <p class="loading">Loading...</p>
</div>
<mat-paginator
  [length]="studentState?.totalCount"
  [pageSize]="pageSize"
  [pageSizeOptions]="[5, 10, 25, 100]"
  [showFirstLastButtons]="true"
  (page)="changePage.emit($event)"
  #scPaginator
>
</mat-paginator>
<img
  *ngIf="showRightArrow"
  src="../../assets/images/{{ rightArrowImgName }}.svg"
  (click)="arrowClicked('right')"
  (mouseenter)="highlightArrow('enter', 'right')"
  (mouseleave)="highlightArrow('leave', 'right')"
  class="keyboard-arrow-right"
  [ngClass]="{
    'stuck-header-arrow': headerIsStuck,
    'unstuck-header-arrow': !headerIsStuck,
    'long-page-keyboard-arrow': isLongPage,
    'keyboard-arrow': !isLongPage
  }"
/>
<img
  *ngIf="showLeftArrow"
  src="../../assets/images/{{ leftArrowImgName }}.svg"
  (click)="arrowClicked('left')"
  (mouseenter)="highlightArrow('enter', 'left')"
  (mouseleave)="highlightArrow('leave', 'left')"
  class="keyboard-arrow-left"
  [ngClass]="{
    'stuck-header-arrow': headerIsStuck,
    'unstuck-header-arrow': !headerIsStuck,
    'long-page-keyboard-arrow': isLongPage,
    'keyboard-arrow': !isLongPage
  }"
/>
